<template>
  <section class="business-hero">
    <div class="business-hero__container container">
      <div class="business-hero__content section grid-css">
        <h1 class="business-hero__headline" v-html="$t('headline')" />

        <div class="business-hero__copy">
          <div class="business-hero__subheadline">
            {{ $t("subheadline") }}
          </div>

          <div class="business-hero__footer">
            <button-component
              href="plans"
              :is-cta="true"
              :use-router="true"
              event-category="body-20210217-business_hero"
              event-name="plans"
            >
              {{ $t("cta") }}
            </button-component>
          </div>
        </div>
      </div>

      <div class="business-hero__picture">
        <div class="business-hero__picture-inner">
          <svg class="business-hero__wave" viewBox="0 0 300 468" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M300 0C300 217 149.39 172.116 71.5281 371.499C55.9598 416.22 30.6563 447.162 0 468V0H300Z"
              fill="#044063"
            />
          </svg>

          <img
            class="business-hero__image"
            srcset="../images/hero/hero@2x.jpg 2x"
            src="../images/hero/hero.jpg"
            :alt="$t('headline')"
          />

          <svg
            class="business-hero__wave business-hero__wave--right"
            viewBox="0 0 214 468"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M214 468V0C214 121.448 180.348 160.866 140.976 206.986C109.998 243.271 75.4799 283.704 51.0234 371.499C39.918 416.22 21.8682 447.162 0 468H214Z"
              fill="#044063"
            />
          </svg>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ButtonComponent from "@/shared/button"

export default {
  name: "BusinessHero",
  components: {
    ButtonComponent
  },
  i18n: {
    messages: {
      en: {
        headline: "The secret to innovative&nbsp;teams?<br />They’re always learning.",
        subheadline:
          "Turn ordinary moments into extraordinary learning opportunities with the world's #1 microlearning app!",
        cta: "Get started"
      },
      de: {
        headline: "Was macht ein Team erfolgreich?<br />Das Wissen und die Fähigkeiten, Großes zu erreichen.",
        subheadline:
          "Blinkist ist eine App, die die Kernaussagen von Sachbüchern so aufbereitet, dass sie ideal verstanden und angewendet werden können – in nur 15 Minuten pro Titel.",
        cta: "Jetzt loslegen"
      }
    }
  }
}
</script>

<style lang="scss">
.business-hero {
  position: relative;

  overflow: hidden;

  background-color: $midnight4;

  &__content {
    position: relative;
    z-index: 2;

    display: flex;
    flex-direction: column;
    align-items: center;

    text-align: center;
  }

  &__headline {
    @include grid-css-element(12);
    @include font-style(h2, $color: $white);

    margin-bottom: $spacing-32;
  }

  &__copy {
    @include grid-css-element(12);
  }

  &__subheadline {
    @include font-style(p, $color: $white);

    margin-bottom: $spacing-32;
  }

  &__footer {
    @include grid-css-element(12);
  }

  &__picture {
    position: absolute;
    top: 0;
    left: 45%;
    z-index: 1;

    display: none;
    height: 100%;
  }

  &__picture-inner {
    height: 100%;
  }

  &__image {
    z-index: 1;

    height: 100%;

    object-fit: contain;
  }

  &__wave {
    position: absolute;
    top: 0;
    left: -1px;
    z-index: 2;

    height: 100%;

    &--right {
      right: -1px;
      left: auto;
    }
  }

  @include media(min-width, s) {
    &__image {
      right: -container-padding(s);
    }
  }

  @include media(min-width, m) {
    &__content {
      align-items: flex-start;

      text-align: left;
    }

    &__headline {
      @include font-style(h1, $color: $white);
      @include grid-css-element(8);
    }

    &__copy {
      @include grid-css-element(6);
    }

    &__subheadline {
      @include font-style(p0, $color: $white);
    }

    &__picture {
      position: absolute;

      display: block;
    }
  }
}
</style>
